import * as React from 'react';
import * as UserActions from '../../actions/users';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { RootState } from '../../reducers';
import Audio from './audio';
import Draw from './draw';
import { Overlay } from './replay';
import { StartOverlay } from './start';
import * as StoryActions from '../../actions/story';
import { StudentData } from '../../models/Student';
import { CampaignData } from '../../models/Campaign';
import { StoryData, emptyStory, StoryInfo } from '../../models/Story';
import { Evaluation } from '../../models/Evaluation';
import * as request from 'superagent';
import { detect } from 'detect-browser';
import Loadable from 'react-loading-overlay';
import {zipPositionJSON, unzipPositionJSON, zipZoomJSON, unzipZoomJSON} from './packJSON';

const TIME = 60 * 5;

export namespace Play {
	export interface Props extends RouteComponentProps<void> {
		storyActions: typeof StoryActions;
		student: StudentData;
		campaign: CampaignData;
		story: StoryData;
		stories: StoryInfo[];
	}
	export interface State {
		timer: number;
		loading: boolean;
		finished: boolean;
		started: boolean;
		saving: boolean;
		mounted: boolean;
	}
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Play extends React.Component<Play.Props, Play.State> {

	audio: Audio;
	draw: Draw;
	audioBlob: Blob;
	timer: any;
	waitingForAudioLoad: boolean;

	static contextTypes = {
		router: React.PropTypes.func.isRequired
	};

	constructor(props: Play.Props) {
		super(props);
		this.draw = new Draw();
		this.audio = new Audio();
		this.audioBlob = null;

		this.saveStory = this.saveStory.bind(this);
		this.finishStory = this.finishStory.bind(this);
		this.fastReplay = this.fastReplay.bind(this);
		this.replay = this.replay.bind(this);
		this.navigateBack = this.navigateBack.bind(this);
		this.start = this.start.bind(this);
		this.mount = this.mount.bind(this);

		let storyDoesExist = storyExists(props.story);

		this.state = {
			timer: TIME,
			loading: storyDoesExist,
			finished: storyDoesExist,
			started: storyDoesExist,
			saving: false,
			mounted: false
		};
	}

	start() {
		this.startTimer();
		this.draw.start();
		this.audio.record();
		this.setState({
			started: true
		});
	}

	startTimer() {
		if (this.timer) {
			window.clearInterval(this.timer);
		}
		this.timer = setInterval(
			() => {
				if (this.state.timer > 0 && !this.state.finished) {
					this.setState({timer: this.state.timer - 1});
				}

				if (this.state.timer <= 0) {
					this.finishStory({});
				}
			},
			1000
		);
	}

	componentDidMount() {
		if(this.props.campaign) {
			this.mount();
		}
	}

	mount(){
		let replay: boolean = storyExists(this.props.story);

		let activeEvals = this.props.campaign.evaluations.filter((o) => { return o.amount > 0; });

		this.draw.init(activeEvals, replay);

		if (!replay) {
			this.audio.init();
		} else {
			let audioElement = document.getElementById('replay') as HTMLAudioElement;

			request
			.get('/story/authenticate')
			.set('Authorization', localStorage.getItem('token') || localStorage.getItem('studenttoken'))
			.query({id: this.props.story.info._id})
			.end((err, res) => {

				const token = res.body.token;			

				request
				.get('/story/positions')
				.query({token})
				.end((err, res) => {
					let positions = JSON.parse(res.text);
					if(positions[0][0][2]) {
						positions = unzipPositionJSON(positions);
					}

					for (let i = 0; i < positions.length; i++) {
						this.draw.elementHistory[i].positions = positions[i]; 	
					}
				});

				request
				.get('/story/zoomHistory')
				.query({token})
				.end((err, res) => {
					let zoomHistory = JSON.parse(res.text);
					if(zoomHistory[0].z) {
						zoomHistory = unzipZoomJSON(zoomHistory);
					}
					this.draw.zoomHistory = zoomHistory;
				});

				audioElement.src = '../../story/audio?token=' + token;
			});
		}
		this.setState({mounted: true});
	}

	finishStory(e: any) {
		if (e.preventDefault) {
			e.preventDefault();
		}

		this.setState({finished: true, saving: true});

		this.draw.stop();
		this.audio.stop((mp3Audio: Blob, wavAudio: Blob) => {
			this.audioBlob = mp3Audio;
			let audioElement = document.getElementById('replay') as HTMLAudioElement;
			audioElement.src = URL.createObjectURL(wavAudio);
			audioElement.pause();
			audioElement.currentTime = 0;
			this.saveStory();
		});
	}

	saveStory() {
		const { storyActions } = this.props;
		const storyData: StoryData = {
			info: {
				_id: this.props.story.info._id,
				date: new Date(),
				campaign: this.props.campaign._id,
				student: this.props.student._id,
				lengthInSeconds: TIME - this.state.timer,
				evaluations: this.draw.symbols.filter((symbol) => { return symbol.dragAndDrop.used; })
				.map((symbol) => { return symbol.evaluation; })
			},
			positions: zipPositionJSON(this.draw.elementHistory.map((o) => { return o.positions; })),
			zoomHistory: zipZoomJSON(this.draw.zoomHistory),
			audio: this.audioBlob
		};
		storyActions.addStory(storyData);
		//this.navigateBack();
	}

	componentDidUpdate(prevProps) {
		if(!this.state.mounted){
			this.mount();
		}
		if(this.props.stories.length > prevProps.stories.length) {
			this.navigateBack();
		}
	}

	navigateBack() {
		this.draw.deleteInterval();
		window.clearInterval(this.timer);
		this.context.router.history.goBack();
	}

	fastReplay() {
		this.draw.initializeReplay();
		let perf1 = performance.now();
		this.replay();
	}

	replay() {
		if (this.waitingForAudioLoad) return;
		this.waitingForAudioLoad = true;
		
		let audioElement = document.getElementById('replay') as HTMLAudioElement;
		audioElement.volume = 1;
		audioElement.play();
		audioElement.muted = false;

		function start() {
			this.waitingForAudioLoad = false;
			this.setState({loading: false, finished: false, timer: TIME});
			this.startTimer();

			this.draw.replay(function(){
				this.draw.stop();
				this.setState({finished: true, timer: TIME});
			}.bind(this));
		}

		if (detect().name === "safari") {
			let audioLoaded = new Promise((resolve, reject) => {
				audioElement.oncanplaythrough = resolve;
				audioElement.onerror = reject;
			}).then(start.bind(this));
		} else {
			start.call(this);
		}

		this.setState({loading: false, finished: false});
		this.startTimer();
		this.draw.replay(function(){
			this.draw.stop();
			this.setState({finished: true, timer: TIME});
		}.bind(this));
	}

	render() {
		let timer = Math.floor(this.state.timer / 60) + ':' + (this.state.timer % 60 < 10 ? '0' : '') + (this.state.timer % 60);

		let overlay;
		let greenButton;
		let redButton;

		if (storyExists(this.props.story)) {
			if (this.state.finished) {
				overlay = <Overlay duration={this.props.story.info.lengthInSeconds} replay={this.replay}/>;
			}
			
			redButton = <button onClick={this.navigateBack} className="btn col-4 form-control am_orange-button">PALAA</button>;
		} else if (!this.state.started) {
			overlay = <StartOverlay start={this.start} />;
			redButton = <button onClick={this.navigateBack} className="btn col-4 form-control am_orange-button">PALAA</button>;
		} else {
			greenButton = (
							<button onClick={this.finishStory} className="btn col-4 form-control am_green-button">
								<img src="/images/GreenConfirmButton.png" className="am_smallicon" />
								VALMISTA TULI
							</button>
						);
			redButton = <button onClick={this.navigateBack} className="btn col-4 form-control am_orange-button">PALAA</button>;
		}

		return (
			<div>
				<canvas id="app"/>
				{overlay}
				<div className="am_playdiv">
				<div className="row am_nomargin">
					{redButton}
					<h1 className="col-4">{timer}</h1>
					{greenButton}
					<div id="audioParent">
						<audio id="replay" controls={true}/>
					</div>
				</div>
				</div>
				<Loadable
					active={this.state.saving}
					spinner
					text="Tallennetaan"
				/>
				<div className="am_hidden">
					{this.props.stories.map((s) => s._id)}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: RootState, data: any) {

	let campaign;

	for(let group in state.groups){
		let searchedCampaign = state.groups[group].campaigns.find((campaign) => campaign._id === data.match.params.campaignid );
		if(searchedCampaign){
			campaign = searchedCampaign;
		}
	}

	let story = emptyStory(data.match.params.storyid);
	let foundInfo = state.stories.find((o) => { return o._id === data.match.params.storyid; });

	if (foundInfo) {
		story.info = foundInfo;
	}

	return {
		student: state.student,
		campaign: campaign,
		story: story,
		stories: state.stories
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		storyActions: bindActionCreators(StoryActions as {}, dispatch)
	};
}

function storyExists(story: any) {
	return story.info.date != null;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Play/index.tsx